import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'
import { Tabs, Tab } from '../../../molecules/Tabs'
import AdminPage from '../../admin/shared/AdminPage'
import PolicyAuthorization from '../../../atoms/PolicyAuthorization'
import { usePolicy } from '../../../../hooks/usePolicy'
import CatalogTables from './CatalogTables'
import CatalogPipelines from './CatalogPipelines'
import CatalogActions from './CatalogActions'

function CatalogHome ({ root }) {
  const { type } = useParams()
  const history = useHistory()
  const tablesEnabled = usePolicy('admin_denali_catalog_tables')
  const pipelinesEnabled = usePolicy('admin_denali_catalog_pipelines')
  const actionsEnabled = usePolicy('admin_denali_internal')
  const onTabChange = useCallback((tab) => {
    history.replace(`${root}/catalog/list/${tab}`)
  }, [history, root])

  useEffect(() => {
    if (!type) {
      history.replace(`${root}/catalog/list/tables`)
    }
  }, [type, root, history])

  if (!type) {
    return (
      <AdminPage />
    )
  }

  return (
    <AdminPage>
      <Tabs.Wrapper>
        <Tabs
          value={type}
          onChange={(_, tabValue) => onTabChange(tabValue)}
        >
          {tablesEnabled ? <Tab value='tables' label='Tables' /> : null}
          {pipelinesEnabled ? <Tab value='pipelines' label='Pipelines' /> : null}
          {actionsEnabled ? <Tab value='actions' label='Actions' /> : null}
        </Tabs>
      </Tabs.Wrapper>
      <Switch>
        <Route path={`${root}/catalog/list/tables`}>
          <PolicyAuthorization policy='admin_denali_catalog_tables'>
            <CatalogTables root={root} />
          </PolicyAuthorization>
        </Route>
        <Route path={`${root}/catalog/list/pipelines`}>
          <PolicyAuthorization policy='admin_denali_catalog_pipelines'>
            <CatalogPipelines root={root} />
          </PolicyAuthorization>
        </Route>
        <Route path={`${root}/catalog/list/actions`}>
          <PolicyAuthorization policy='admin_denali_internal'>
            <CatalogActions root={root} />
          </PolicyAuthorization>
        </Route>
      </Switch>
    </AdminPage>
  )
}

CatalogHome.propTypes = {
  root: PropTypes.string
}

export default CatalogHome
